package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import io.horion.cv.components.widgets.DateRangeSelector
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.RichTextDescription
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.EntryState
import org.jetbrains.compose.web.css.px

@Composable
fun EntryForm(
    state: EntryState,
    onDelete: () -> Unit,
    onComplete: () -> Unit
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(25.px),
    ) {
        TextFormField(
            label = "Titre",
            value = state.title,
            onValueChange = { state.title = it },
            modifier = Modifier.fillMaxWidth(),
        )
        TextFormField(
            label = "Résumé",
            value = state.resume,
            onValueChange = { state.resume = it },
            modifier = Modifier.fillMaxWidth(),
        )

        DateRangeSelector(
            startMonth = state.moisDebut,
            startYear = state.anneeDebut,
            endMonth = state.moisFin,
            endYear = state.anneeFin,
            isOngoing = state.isOngoing,
            onStartMonthChange = { state.moisDebut = it },
            onStartYearChange = { state.anneeDebut = it },
            onEndMonthChange = { state.moisFin = it },
            onEndYearChange = { state.anneeFin = it },
            onOngoingChange = {
                state.isOngoing = it
                if (it) {
                    state.moisFin = ""
                    state.anneeFin = ""
                }
            }
        )

        RichTextDescription(
            label = "Description",
            value = state.description,
            onValueChange = {
                state.description = it
            },
            modifier = Modifier.fillMaxWidth(),
        )

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}